import { lazy } from 'react';
import { Navigate, type RouteObject } from 'react-router';
import { RequireRole } from '@/lib/auth/guards';

const AdminLayout = lazy(() => import('./admin-layout').then((m) => ({ default: m.AdminLayout })));
const AgentsSettingsTab = lazy(() => import('./agents-settings-tab').then((m) => ({ default: m.AgentsSettingsTab })));
const AiProvidersTab = lazy(() => import('./ai-providers-tab').then((m) => ({ default: m.AiProvidersTab })));
const AssignmentRulesTab = lazy(() => import('./assignment-rules-tab').then((m) => ({ default: m.AssignmentRulesTab })));
const AuditTab = lazy(() => import('./audit-tab').then((m) => ({ default: m.AuditTab })));
const AuthTab = lazy(() => import('./auth-tab').then((m) => ({ default: m.AuthTab })));
const EmailTab = lazy(() => import('./email-tab').then((m) => ({ default: m.EmailTab })));
const GeneralTab = lazy(() => import('./general-tab').then((m) => ({ default: m.GeneralTab })));
const GroupsTab = lazy(() => import('./groups-tab').then((m) => ({ default: m.GroupsTab })));
const IntegrationsTab = lazy(() => import('./integrations-tab').then((m) => ({ default: m.IntegrationsTab })));
const NotificationRulesTab = lazy(() => import('./notification-rules-tab').then((m) => ({ default: m.NotificationRulesTab })));
const SlaTab = lazy(() => import('./sla-tab').then((m) => ({ default: m.SlaTab })));
const UsersPage = lazy(() => import('./users-page').then((m) => ({ default: m.UsersPage })));

export const adminRoutes: RouteObject[] = [
  {
    path: 'admin',
    element: <RequireRole roles={['admin']} />,
    handle: { crumb: 'Administration' },
    children: [
      {
        element: <AdminLayout />,
        children: [
          { index: true, element: <Navigate to="users" replace /> },
          { path: 'users', element: <UsersPage />, handle: { crumb: 'Users' } },
          { path: 'general', element: <GeneralTab />, handle: { crumb: 'General' } },
          { path: 'groups', element: <GroupsTab />, handle: { crumb: 'Groups' } },
          { path: 'sla', element: <SlaTab />, handle: { crumb: 'SLA Policies' } },
          { path: 'assignment-rules', element: <AssignmentRulesTab />, handle: { crumb: 'Assignment Rules' } },
          { path: 'ai-providers', element: <AiProvidersTab />, handle: { crumb: 'AI Providers' } },
          { path: 'agents', element: <AgentsSettingsTab />, handle: { crumb: 'AI Agents' } },
          { path: 'notification-rules', element: <NotificationRulesTab />, handle: { crumb: 'Notification Rules' } },
          { path: 'email', element: <EmailTab />, handle: { crumb: 'Email' } },
          { path: 'auth', element: <AuthTab />, handle: { crumb: 'Authentication' } },
          { path: 'integrations', element: <IntegrationsTab />, handle: { crumb: 'Integrations' } },
          { path: 'audit', element: <AuditTab />, handle: { crumb: 'Audit Log' } },
        ],
      },
    ],
  },
];
